import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/src/components/layout-wiki/index.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1>{`Bitwig Studio Community`}</h1>
    <p>{`Below are some of the Bitwig Studio community resources available online:`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://answers.bitwig.com/"
        }}>{`Bitwig Q&A`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://bitwig.community/"
        }}>{`Bitwig Studio Community`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://discord.gg/0g2ZPafIN3eWParf"
        }}>{`Bitwig Discord chat`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.kvraudio.com/forum/viewforum.php?f=259"
        }}>{`KVR Forums / Bitwig`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.reddit.com/r/Bitwig/"
        }}>{`r/Bitwig`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      